//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import comicobject from '../script/comicobject'
import tabinfoobject from '../script/tabinfoobject'

export default {
  name: "comicshow",
  mixins: [comicobject, tabinfoobject],
  data() {
    return {
      comin_data_error_mark: false,
      star_loading: false,
      cover_url: undefined,
      comic_rows: [],
      ROW_COUNT: this._g.COMMON_ROW_COUNT,
      chapter_list: undefined,
      manhua_conf: undefined,
      g: this._g,
    }
  },
  watch: {
    "g.COMMON_ROW_COUNT": {
      handler(new_value, old_value) {
        console.log("_g.COMMON_ROW_COUNT:", new_value, old_value);
        this.ROW_COUNT = this._g.COMMON_ROW_COUNT;
        try {
          this.comic_rows = this.do_comic_list(this.$store.state.init.data.latest_datas.japan.datas, this.ROW_COUNT);
        } catch (e) {
          console.log("e:", e)
        }
      },
      immediate: true,
    },
    '$route'(to, from) {
      this.load_comic_data({id: this.$route.params.id});
      this.load_tabinfo(this.$route.params.id);
    }
  },
  created() {
    this.listener_init = this.$hub.on('event:init', () => {
      this.comic_rows = this.do_comic_list(this.$store.state.init.data.latest_datas.japan.datas, this.ROW_COUNT);
      this.$forceUpdate();
    });

    window._t = this;
    this.load_comic_data({id: this.$route.params.id});
    this.load_tabinfo(this.$route.params.id);

    try {
      this.comic_rows = this.do_comic_list(this.$store.state.init.data.latest_datas.japan.datas, this.ROW_COUNT);
    } catch (e) {
      console.log("e:", e)
    }
  }
  ,
  destroyed() {
    this.listener_init.off();
  },
  computed: {
    total_chapter: function () {
      if (this.comic_data) {
        return this.compute_total_chapter(this.comic_data).length;
      }
    }
  },
  methods: {
    star_click: function () {
      if (!this.$store.state.hasLogin) {
        return this.$app._userbar.show_login_dialog();
      }
      this.star_loading = true;
      var post_data = {
        'id': this.comic_data.id,
        'action': !this.tabinfo.isstar
      };
      this.$axios.post('/app/comic/star', post_data).then((response) => {
        this.star_loading = false;
        var response_data = response.data;
        console.log("response_data:", response_data)
        this.tabinfo.isstar = !this.tabinfo.isstar;
      }).catch((error) => {
        console.log('error:', error);
        this.star_loading = false;
      });
    },
    on_comic_data_change: function (comic_data) {
      this.comic_data = comic_data;

      var title = this.comic_data.title;
      this.set_title(title);
      this.add_keywords(title);
      this.add_description(title);

      var space_name = this.comic_data.photo_object.space_name;
      var cover_hash_id = this.comic_data.photo_object.cover;
      this.cover_url = this.generate_cover_url(space_name, this.comic_data.id, cover_hash_id)
      this.chapter_list = this.generate_chapter_list(this.comic_data);
      this.manhua_conf = this.get_manhua_by_country(this.comic_data.country);

      this.chapter_list = this.generate_chapter_list(this.comic_data);
      console.log("this.chapter_list:", this.chapter_list);

    },
    on_comin_data_error: function (id, error) {
      this.comin_data_error_mark = true;
    },
    on_tabinfo_change: function (tabinfo) {
      this.tabinfo = Object.assign(this.tabinfo, tabinfo)
      this.$forceUpdate();
    },
    update_already_buy_chapters: function () {
      var comic_buy = this.tabinfo.comic_buy;
      if (comic_buy) {
        if (Array.isArray(comic_buy.chapter_list) && comic_buy.chapter_list.indexOf(this.current_chapter) >= 0) {
          console.log('已购买comic_buy:', comic_buy)
          this.buy_chapter.is_need_buy = false;
          return;
        }
      }
    }
  }
}
